import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { Directive } from '@angular/core';

export function protocolRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid =
      control.value.trim() === '' ||
      control.value.toLowerCase().indexOf('http://') > -1 ||
      control.value.toLowerCase().indexOf('https://') > -1;
    return valid ? null : { protocolRequired: true };
  };
}

@Directive({
  selector: '[protocolRequired]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ProtocolRequiredDirective, multi: true }],
  standalone: false
})
export class ProtocolRequiredDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return protocolRequiredValidator()(control);
  }
}
